module.exports = __webpack_public_path__ + "static/media/Why Choose 2.1587e7a6.png";